import { render, staticRenderFns } from "./PanelComponentBlock.vue?vue&type=template&id=80b62664"
import script from "./PanelComponentBlock.vue?vue&type=script&lang=js"
export * from "./PanelComponentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports